var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#facebook_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1877F2",
    d: "M16 8.5a8 8 0 1 0-9.25 7.903v-5.59H4.719V8.5H6.75V6.737c0-2.005 1.194-3.112 3.022-3.112.875 0 1.79.156 1.79.156V5.75h-1.008C9.56 5.75 9.25 6.367 9.25 7v1.5h2.219l-.355 2.313H9.25v5.59A8.002 8.002 0 0 0 16 8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.114 10.813 11.47 8.5H9.25V7c0-.633.31-1.25 1.304-1.25h1.008V3.781s-.915-.156-1.79-.156c-1.828 0-3.022 1.107-3.022 3.112V8.5H4.719v2.313H6.75v5.59c.828.13 1.672.13 2.5 0v-5.59h1.864Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "facebook_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h16v16H0z"
  })))));
};
export default SvgFacebook;